// ============================================================================
// KLINISOL ILO Platform Page
// Exact 1:1 JSX port of ILO_OnePager.html — word for word
// ============================================================================

export default function KLINISOLILOPlatform() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=JetBrains+Mono:wght@500;600&display=swap');

        :root {
          --slate:   #475569;
          --slate2:  #334155;
          --magenta: #E91E63;
          --mag2:    #F06292;
          --muted:   #64748B;
          --line:    #E2E8F0;
          --bg:      #F8FAFD;
          --white:   #FFFFFF;
          --text:    #1E293B;
        }
        .ilo-page *{box-sizing:border-box;margin:0;padding:0;}
        .ilo-page{font-family:'DM Sans',sans-serif;background:var(--bg);color:var(--text);font-size:14px;line-height:1.6;-webkit-font-smoothing:antialiased;}
        .page{max-width:1080px;margin:0 auto;padding:28px 22px 48px;}

        /* HERO */
        .hero{background:linear-gradient(to right, #475569, #E91E63, #475569);border-radius:20px;overflow:hidden;position:relative;box-shadow:0 20px 56px rgba(51,65,85,.25);}
        .hero::after{content:"";position:absolute;top:-80px;right:-80px;width:380px;height:380px;background:radial-gradient(circle,rgba(255,255,255,.12) 0%,transparent 65%);pointer-events:none;}
        .hero-top{padding:32px 36px 28px;position:relative;z-index:1;}
        .hero-eyebrow{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:12px;margin-bottom:20px;}
        .brand-name{font-size:19px;font-weight:700;color:#fff;letter-spacing:.01em;}
        .brand-name .i{color:var(--magenta);}
        .brand-reg{font-size:.5em;vertical-align:super;opacity:.7;}
        .hero-badge{border:1px solid rgba(255,255,255,.45);background:rgba(255,255,255,.15);color:#fff;font-size:10.5px;font-weight:600;letter-spacing:.07em;text-transform:uppercase;padding:6px 14px;border-radius:999px;white-space:nowrap;}
        .hero-rule{height:1px;background:linear-gradient(90deg,transparent,rgba(255,255,255,.14),transparent);margin:0 0 24px;}
        .hero-h1{font-family:'DM Serif Display',serif;font-size:36px;line-height:1.08;color:#fff;max-width:840px;margin-bottom:14px;letter-spacing:-.02em;}
        .hero-h1 em{color:#ffffff;font-style:italic;}
        .cfr-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(255,255,255,.15);border:1px solid rgba(255,255,255,.45);color:#fff;border-radius:8px;padding:7px 16px;font-size:11px;font-weight:700;letter-spacing:.03em;margin-bottom:18px;}
        .cfr-badge .dot{width:7px;height:7px;border-radius:50%;background:#fff;flex-shrink:0;}
        .hero-p{font-size:13px;color:#ffffff;max-width:780px;line-height:1.65;margin-bottom:20px;}
        .pill-row{display:flex;flex-wrap:wrap;gap:8px;}
        .pill{border:1px solid rgba(255,255,255,.22);background:rgba(255,255,255,.09);color:rgba(255,255,255,.92);border-radius:999px;padding:5px 13px;font-size:11px;font-weight:600;letter-spacing:.02em;white-space:nowrap;}
        .hero-foot{border-top:1px solid rgba(255,255,255,.1);padding:18px 36px 22px;font-size:12px;color:#ffffff;line-height:1.65;position:relative;z-index:1;}
        .hero-foot strong{color:#ffffff;}

        /* SECTION */
        .section{margin-top:16px;background:var(--white);border:1px solid var(--line);border-radius:20px;overflow:hidden;box-shadow:0 4px 20px rgba(51,65,85,.06);}
        .section-head{padding:13px 20px;background:rgba(71,85,105,.04);border-bottom:1px solid var(--line);display:flex;align-items:baseline;justify-content:space-between;flex-wrap:wrap;gap:8px;}
        .section-title{font-size:10.5px;font-weight:700;text-transform:uppercase;letter-spacing:.14em;color:var(--slate2);}
        .section-sub{font-size:10.5px;color:var(--muted);font-weight:500;}
        .section-body{padding:16px 20px 20px;}

        /* MODULES */
        .mod-box{border:1px solid var(--line);border-radius:14px;overflow:hidden;}
        .mod-label{padding:8px 13px;background:rgba(71,85,105,.04);border-bottom:1px solid var(--line);font-size:9.5px;font-weight:700;text-transform:uppercase;letter-spacing:.13em;color:var(--slate2);}
        .mod-row{display:grid;border-bottom:1px solid var(--line);}
        .mod-row:last-child{border-bottom:none;}
        .mod-row.r5{grid-template-columns:repeat(5,1fr);}
        .mod-row.r6{grid-template-columns:repeat(6,1fr);}
        .mod{padding:13px 9px 11px;text-align:center;border-right:1px solid var(--line);display:flex;flex-direction:column;align-items:center;gap:4px;}
        .mod:last-child{border-right:none;}
        .mod-icon{font-size:19px;line-height:1;}
        .mod-name{font-size:10.5px;font-weight:700;color:var(--slate2);line-height:1.15;}
        .mod-desc{font-size:9px;color:var(--muted);line-height:1.3;font-weight:500;}

        /* CARDS */
        .grid-2{display:grid;grid-template-columns:1fr 1fr;gap:11px;}
        .card{border:1px solid var(--line);border-radius:14px;padding:13px 15px 12px;position:relative;overflow:hidden;background:var(--white);}
        .card::before{content:"";position:absolute;top:0;left:0;right:0;height:3px;background:var(--magenta);}
        .card h3{font-size:13px;font-weight:700;color:var(--slate2);margin-bottom:6px;line-height:1.2;}
        .card p{font-size:11.5px;color:#374151;line-height:1.55;}

        /* NUMBERS STRIP */
        .numbers-strip{margin-top:16px;background:linear-gradient(to right, #475569, #E91E63, #475569);border-radius:16px;padding:18px 24px;display:flex;align-items:center;justify-content:center;flex-wrap:wrap;box-shadow:0 4px 20px rgba(51,65,85,.12);}
        .num-item{display:flex;align-items:baseline;gap:6px;padding:4px 22px;border-right:1px solid rgba(255,255,255,.22);}
        .num-item:last-child{border-right:none;}
        .num-val{font-family:'DM Serif Display',serif;font-size:22px;color:#ffffff;line-height:1;white-space:nowrap;}
        .num-label{font-size:10.5px;font-weight:600;color:rgba(255,255,255,.62);white-space:nowrap;}

        /* CTA */
        .cta{margin-top:16px;background:linear-gradient(to right, #475569, #E91E63, #475569);border-radius:20px;padding:28px 32px;display:flex;align-items:center;justify-content:space-between;gap:20px;flex-wrap:wrap;box-shadow:0 12px 40px rgba(51,65,85,.18);position:relative;overflow:hidden;}
        .cta::after{content:"";position:absolute;bottom:-50px;right:-50px;width:240px;height:240px;background:radial-gradient(circle,rgba(255,255,255,.12) 0%,transparent 70%);pointer-events:none;}
        .cta-text{position:relative;z-index:1;}
        .cta-text h2{font-family:'DM Serif Display',serif;font-size:24px;color:#fff;line-height:1.15;margin-bottom:7px;}
        .cta-text p{font-size:12.5px;color:rgba(255,255,255,.7);max-width:560px;line-height:1.6;}
        .cta-right{position:relative;z-index:1;text-align:right;flex-shrink:0;}
        .cta-label{font-size:10px;font-weight:600;color:rgba(255,255,255,.45);letter-spacing:.08em;text-transform:uppercase;}
        .cta-rule{height:1px;width:190px;background:rgba(255,255,255,.14);margin:8px 0;}
        .cta-email{font-size:15px;font-weight:700;color:#ffffff;letter-spacing:.01em;}

        /* FOOTER */
        .ilo-footer{margin-top:16px;padding:11px 2px 0;display:flex;justify-content:space-between;flex-wrap:wrap;gap:8px;font-size:10px;color:var(--muted);border-top:1px solid var(--line);}
        .ilo-footer strong{color:var(--slate2);}

        @media(max-width:860px){
          .hero-h1{font-size:26px;}
          .grid-2{grid-template-columns:1fr;}
          .mod-row.r5,.mod-row.r6{grid-template-columns:repeat(3,1fr);}
          .num-item{border-right:none;padding:6px 14px;}
          .cta{flex-direction:column;}
          .cta-right{text-align:left;}
          .cta-rule{width:100%;}
        }
      `}</style>

      <div className="ilo-page">
        <div className="page">

          {/* HERO */}
          <section className="hero">
            <div className="hero-top">
              <div className="hero-eyebrow">
                <div className="brand-name">ILO by KLIN<span className="i">i</span>SOL<span className="brand-reg">®</span></div>
                <div className="hero-badge">Regulated Execution · Protocol to Database Lock</div>
              </div>
              <div className="hero-rule"></div>
              <h1 className="hero-h1">ILO — <em>A Clinical Trial<br />Operating System.</em></h1>
              <div className="cfr-badge"><span className="dot"></span>Built for FDA 21 CFR Part 11 Compliance — not retrofitted for it</div>
              <p className="hero-p">Unified infrastructure replacing fragmented clinical systems — EDC, CTMS, eTMF, IRT, Safety, Randomization, CDISC exports, Budget automation, Data Exchange, Lab reference ranges, and Analytics — operating as native modules inside a single regulated environment.</p>
              <div className="pill-row">
                <span className="pill">AI embedded as infrastructure</span>
                <span className="pill">AI proposes. Humans review &amp; decide.</span>
                <span className="pill">Audit-logged + versioned</span>
                <span className="pill">Inspection-ready by design</span>
                <span className="pill">EHR integration ready</span>
                <span className="pill">AI that knows your study, speaks to your team</span>
              </div>
            </div>
            <div className="hero-foot">ILO is not a tool layered on top of clinical workflows. It is the operating system that governs them. Artificial intelligence is embedded at the infrastructure layer — <strong>never autonomous</strong> — with explicit human approval required before any database commitment.</div>
          </section>

          {/* MODULES */}
          <section className="section">
            <div className="section-head">
              <span className="section-title">Native System Modules</span>
              <span className="section-sub">One regulated environment · shared identity · shared audit · shared compliance engine</span>
            </div>
            <div className="section-body">
              <div className="mod-box">
                <div className="mod-label">Core Platform Modules</div>
                <div className="mod-row r5">
                  <div className="mod"><div className="mod-icon">📋</div><div className="mod-name">EDC</div><div className="mod-desc">Forms, queries, data entry, e-sign submissions</div></div>
                  <div className="mod"><div className="mod-icon">🏥</div><div className="mod-name">CTMS</div><div className="mod-desc">Sites, staff, training, monitoring, CAPA · study metrics dashboard</div></div>
                  <div className="mod"><div className="mod-icon">📁</div><div className="mod-name">eTMF</div><div className="mod-desc">DIA TMF model, zones, artifacts, completeness</div></div>
                  <div className="mod"><div className="mod-icon">💊</div><div className="mod-name">IRT</div><div className="mod-desc">Supply, dispensing, resupply, temperature monitoring</div></div>
                  <div className="mod"><div className="mod-icon">🛡</div><div className="mod-name">kSAFE</div><div className="mod-desc">PV workflows, SAE narratives, 7d/15d reporting · real-time AI safety signal monitoring</div></div>
                </div>
                <div className="mod-row r6">
                  <div className="mod"><div className="mod-icon">🎲</div><div className="mod-name">Randomization</div><div className="mod-desc">Automated randomization · 10 scheme types, stratification</div></div>
                  <div className="mod"><div className="mod-icon">📚</div><div className="mod-name">CDISC Library</div><div className="mod-desc">CDASH/SDTM mappings, Define-XML, validation</div></div>
                  <div className="mod"><div className="mod-icon">💰</div><div className="mod-name">Budget &amp; Finance</div><div className="mod-desc">Contracts, accruals, triggers, scenarios</div></div>
                  <div className="mod"><div className="mod-icon">📤</div><div className="mod-name">Data Exchange</div><div className="mod-desc">Imports/exports, coding, structured outputs</div></div>
                  <div className="mod"><div className="mod-icon">🧪</div><div className="mod-name">Lab Ranges</div><div className="mod-desc">8-level site/age/sex resolution · 3-tier flagging</div></div>
                  <div className="mod"><div className="mod-icon">📊</div><div className="mod-name">kSIGHT</div><div className="mod-desc">AI analytics, executive summary, alert engine</div></div>
                </div>
              </div>
            </div>
          </section>

          {/* COMPLIANCE */}
          <section className="section">
            <div className="section-head">
              <span className="section-title">Built for Inspection — Not Retrofitted for It</span>
              <span className="section-sub">FDA 21 CFR Part 11-aligned controls · identity-first architecture · immutable audit</span>
            </div>
            <div className="section-body">
              <div className="grid-2">
                <div className="card"><h3>Human-in-the-Loop Mandatory</h3><p>Every AI suggestion requires explicit human approval before committing to the database. No autonomous AI decisions.</p></div>
                <div className="card"><h3>Complete Audit Trail</h3><p>User ID, timestamp, model version, confidence score, processing time — captured as immutable, append-only records.</p></div>
                <div className="card"><h3>Electronic Signatures (21 CFR Part 11)</h3><p>Re-authentication, meaning statement, and timestamped signatures for submissions, approvals, and controlled changes.</p></div>
                <div className="card"><h3>RBAC-Gated AI Access</h3><p>Role-based enforcement across operations with denial logged when unauthorized. Prevents unauthorized AI exposure by design.</p></div>
                <div className="card"><h3>MFA + Session Governance</h3><p>Multi-factor authentication, lockout policies, configurable inactivity timeouts, and token invalidation on logout.</p></div>
                <div className="card"><h3>Document Integrity Controls</h3><p>Checksum verification at upload and before ingestion; tampered files rejected before entering the knowledge pipeline.</p></div>
                <div className="card"><h3>Confidence Transparency</h3><p>Every AI output carries a confidence score; low-confidence results are flagged for mandatory human review.</p></div>
                <div className="card"><h3>Voice PHI Protection</h3><p>Audio processed in-memory only; transcripts and audit metadata persist without storing audio on disk.</p></div>
              </div>
            </div>
          </section>

          {/* NUMBERS STRIP */}
          <div className="numbers-strip">
            <div className="num-item"><span className="num-val">11</span><span className="num-label">Modules</span></div>
            <div className="num-item"><span className="num-val">580+</span><span className="num-label">API Endpoints</span></div>
            <div className="num-item"><span className="num-val">432</span><span className="num-label">Edit Check Templates</span></div>
            <div className="num-item"><span className="num-val">36</span><span className="num-label">CFR Part 11 Controls</span></div>
            <div className="num-item"><span className="num-val">98%</span><span className="num-label">Extraction Confidence</span></div>
            <div className="num-item"><span className="num-val">0</span><span className="num-label">Audio Bytes on Disk</span></div>
          </div>

          {/* CTA */}
          <div className="cta">
            <div className="cta-text">
              <h2>See the Operating System in Action.</h2>
              <p>From protocol extraction to randomized subject in under 10 minutes — governed by unified compliance architecture.</p>
            </div>
            <div className="cta-right">
              <div className="cta-label">Contact</div>
              <div className="cta-rule"></div>
              <div className="cta-email">contact@klinisol.com</div>
            </div>
          </div>

          {/* FOOTER */}
          <footer className="ilo-footer">
            <div><strong>ILO by KLINiSOL®</strong> · A Clinical Trial Operating System · Built for regulated execution</div>
            <div>© 2026 KLINiSOL. All Rights Reserved.</div>
          </footer>

        </div>
      </div>
    </>
  );
}
